"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackScroll = trackScroll;
const browser_core_1 = require("@datadog/browser-core");
const browser_rum_core_1 = require("@datadog/browser-rum-core");
const eventsUtils_1 = require("../eventsUtils");
const types_1 = require("../../../types");
const assembly_1 = require("../assembly");
const SCROLL_OBSERVER_THRESHOLD = 100;
function trackScroll(configuration, scope, scrollCb, elementsScrollPositions, target = document) {
    const { throttled: updatePosition, cancel: cancelThrottle } = (0, browser_core_1.throttle)((event) => {
        const target = (0, eventsUtils_1.getEventTarget)(event);
        if (!target) {
            return;
        }
        const id = scope.nodeIds.get(target);
        if (id === undefined ||
            (0, browser_rum_core_1.getNodePrivacyLevel)(target, configuration.defaultPrivacyLevel) === browser_rum_core_1.NodePrivacyLevel.HIDDEN) {
            return;
        }
        const scrollPositions = target === document
            ? {
                scrollTop: (0, browser_rum_core_1.getScrollY)(),
                scrollLeft: (0, browser_rum_core_1.getScrollX)(),
            }
            : {
                scrollTop: Math.round(target.scrollTop),
                scrollLeft: Math.round(target.scrollLeft),
            };
        elementsScrollPositions.set(target, scrollPositions);
        scrollCb((0, assembly_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.Scroll, {
            id,
            x: scrollPositions.scrollLeft,
            y: scrollPositions.scrollTop,
        }));
    }, SCROLL_OBSERVER_THRESHOLD);
    const { stop: removeListener } = (0, browser_core_1.addEventListener)(configuration, target, "scroll" /* DOM_EVENT.SCROLL */, updatePosition, {
        capture: true,
        passive: true,
    });
    return {
        stop: () => {
            removeListener();
            cancelThrottle();
        },
    };
}
//# sourceMappingURL=trackScroll.js.map